import { useCallback } from 'react'

import { useGetOptions } from '@user/components/Settings/LeadAssignmentRule/hooks'

export function useGetAssignmentRuleConditions() {
  const getOptions = useGetOptions()

  return useCallback(
    (assignmentRuleConditions: any[], type: 'all' | 'locale') =>
      assignmentRuleConditions.map((cond) => {
        const options: any[] =
          cond.attribute !== 'ZipCode'
            ? getOptions(
                cond.attribute == 'State' && type == 'all'
                  ? cond.attribute + 'All'
                  : cond.attribute,
              )
            : []

        return {
          ...cond,
          assignmentRuleConditionValues: cond.assignmentRuleConditionValues.map(
            (value) =>
              cond.attribute === 'ZipCode'
                ? value.value || value
                : options.find((opt: any) => opt.id === (value.value || value)),
          ),
        }
      }),
    [getOptions],
  )
}
